import React, { memo } from 'react';
import { DrawerContentScrollView } from '@react-navigation/drawer';
import { DrawerItemList } from '@redlink/components/muscles';

export const DrawerContent = memo((props) => {
  return (
    <DrawerContentScrollView {...props}>
      <DrawerItemList {...props} />
    </DrawerContentScrollView>
  );
});
